import type { BlockDef } from '@cogo/types-v2'

export function cloneBlockDef(src: unknown): BlockDef {
  return JSON.parse(JSON.stringify(src)) as BlockDef
}

interface RootWithClassName {
  className?: string
  [k: string]: unknown
}
interface BlockDefWithRoot {
  ui: { root: RootWithClassName }
  [k: string]: unknown
}

export function appendRootClassName(block: BlockDef, extra: string): BlockDef {
  const b = block as unknown as BlockDefWithRoot
  b.ui.root.className = `${b.ui.root.className ?? ''} ${extra}`.trim()
  return block
}
